import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

const TabContainer = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100%'
      }}>
      {children}
    </Box>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

export default TabContainer;